import { cn, formatRelativeTime } from '../lib/utils';

interface CacheBadgeProps {
  /** Timestamp when the data was cached (optional) */
  timestamp?: number | null;
  /** Whether the cached data is stale (expired but still being shown) */
  isStale?: boolean;
  className?: string;
}

/**
 * Badge indicating cached data with optional relative timestamp.
 * Shows yellow border when data is stale.
 *
 * Not built on the shared `Badge` primitive — neither state (neutral
 * low-emphasis pill, warning pill) maps onto its variant set without fighting
 * it with override classes, same call as index.css's condition-color badges.
 */
export function CacheBadge({ timestamp, isStale, className }: CacheBadgeProps) {
  const relativeTime = timestamp ? formatRelativeTime(timestamp) : null;

  return (
    <span
      className={cn(
        'rounded px-2 py-0.5 text-xs',
        isStale
          ? 'border border-yellow-600/40 bg-yellow-50 text-yellow-700'
          : 'bg-muted text-muted-foreground',
        className
      )}
      title={isStale ? 'Stale cache - could not refresh' : 'Cached result'}
    >
      cached{relativeTime ? ` ${relativeTime}` : ''}
    </span>
  );
}
